import { useEffect, useState } from 'react';
import { Tabs, Tab } from '@celltrak/ui-components';

import OverviewTab from './OverviewTab';
import AggregatorPayloadTab from './AggregatorPayloadTab';
import VisitPayloadTab from './VisitPayloadTab';
import HistoryTab from './HistoryTab';
import useVisitsTabs from './hooks';

const VisitTabs = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const { isLoading, saveVisitsDetails } = useVisitsTabs();

  useEffect(() => {
    saveVisitsDetails();
  }, []);

  return (
    <Tabs activeTab={activeTab} onSelect={tab => setActiveTab(tab)} fullHeight>
      <Tab title="Overview" tabKey="overview" fullHeight>
        <OverviewTab isLoading={isLoading} />
      </Tab>
      <Tab title="Aggregator Payload" tabKey="aggregatorPayload" fullHeight>
        <AggregatorPayloadTab />
      </Tab>
      <Tab title="Visit Payload" tabKey="visitPayload" fullHeight>
        <VisitPayloadTab />
      </Tab>
      <Tab title="History" tabKey="history" fullHeight>
        <HistoryTab />
      </Tab>
    </Tabs>
  );
};

export default VisitTabs;
